module.exports = __webpack_public_path__ + "img/fukumatu_food.200647aa.jpg";